import { render, staticRenderFns } from "./RemoveConfirmation.vue?vue&type=template&id=147d8869"
import script from "./RemoveConfirmation.vue?vue&type=script&lang=js"
export * from "./RemoveConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports